export function toEmailString(email) {
    if (email == null) return '';
    if (typeof email === 'string') return email;
    if (typeof email === 'object') {
        if (email.address) return String(email.address);
        const address = email.localPart || email.user || email.username || '';
        const domain = email.domain || '';
        const joined = address && domain ? `${address}@${domain}` : address || domain;
        return joined ? String(joined) : '';
    }
    return '';
}

